const debounce = (callback, delay = 1000) => {
  let timeout
  return function () {
    clearTimeout(timeout)
    timeout = setTimeout(callback, delay)
  }
}

export default debounce
